import React, { useState, useEffect, useRef } from 'react';
import { Button, LinearProgress, Typography, Box, Paper, Chip, IconButton, Tooltip } from '@material-ui/core';
import { CheckCircle, Error as ErrorIcon, Warning, Info, FilterList } from '@material-ui/icons';

import axios from 'axios';

const UpdateWordpress = () => {
    const [progress, setProgress] = useState(0);
    const [status, setStatus] = useState('');
    const [consoleMessages, setConsoleMessages] = useState([]);
    const [logFilter, setLogFilter] = useState('all');
    const consoleEndRef = useRef(null);

    const handleUpdate = async () => {
        setConsoleMessages([]);
        setStatus('Récupération des Produits à mettre à jour...');
        const now = () => new Date().toLocaleTimeString();
        try {
            // 1. Récupération des produits
            const response = await axios.get('https://extensia-france.com/api/wordpress/get_product.php');
            const { products, listProd, listVariation } = response.data;
            setProgress(10);

            // 2. Préparation de la liste d'images à vérifier
            setStatus('Vérification des images existantes sur WordPress...');
            const allImages = [];
            for (let product of products) {
                for (let variation of product.produits) {
                    if (variation.image) allImages.push(variation.image);
                    if (Array.isArray(variation.gallery)) {
                        for (let galleryImage of variation.gallery) {
                            if (galleryImage) allImages.push(galleryImage);
                        }
                    }
                }
            }
                    const uniqueImages = Array.from(new Set(allImages));
                    setConsoleMessages(prev => [...prev, { level: 'info', message: `Vérification de ${uniqueImages.length} images sur WP...`, time: now() }]);
                    // 3. Vérification groupée

                    // Appel API distante pour vérifier les images présentes sur WP
                    let present = new Set();
                    let missing = new Set();
                    try {
                        const res = await axios.post('https://atcjoaillerie.fr/api/wp_functions.php', {
                            action: 'checkImagesOnWP',
                            images: uniqueImages
                        });
                        if (res.data && res.data.present && res.data.missing) {
                            present = new Set(res.data.present);
                            missing = new Set(res.data.missing);
                        } else {
                            setConsoleMessages(prev => [...prev, { level: 'warning', message: 'Réponse inattendue de wp_functions.php', time: now() }]);
                        }
                    } catch (err) {
                        setConsoleMessages(prev => [...prev, { level: 'error', message: 'Erreur lors de la vérification des images sur WP', time: now(), details: err.message }]);
                    }
                    setConsoleMessages(prev => [...prev, { level: 'info', message: `${present.size} images déjà présentes, ${missing.size} à uploader.`, time: now() }]);
                    setProgress(20);

                    // 4. Upload progressif avec logs "en cours"
                    setStatus('Upload des images manquantes...');
                    const uploadedImages = new Set(present);
                    const imageUploadTasks = [];
                    for (let product of products) {
                        for (let variation of product.produits) {
                            if (variation.image && !uploadedImages.has(variation.image) && missing.has(variation.image)) {
                                setConsoleMessages(prev => [...prev, { level: 'info', message: `⏳ Upload image principale: ${variation.image}`, time: now() }]);
                                const formData = new FormData();
                                formData.append('image', variation.image);
                                imageUploadTasks.push(
                                    axios.post('https://atcjoaillerie.fr/api/wp_upload.php', formData)
                                        .then(() => ({
                                            level: 'success',
                                            message: `Image principale uploadée`,
                                            file: variation.image,
                                            time: now(),
                                        }))
                                        .catch(err => ({
                                            level: 'error',
                                            message: `Erreur upload image principale: ${variation.image}`,
                                            file: variation.image,
                                            time: now(),
                                            details: err.message
                                        }))
                                );
                                uploadedImages.add(variation.image);
                            }
                            if (Array.isArray(variation.gallery)) {
                                for (let galleryImage of variation.gallery) {
                                    if (galleryImage && !uploadedImages.has(galleryImage) && missing.has(galleryImage)) {
                                        setConsoleMessages(prev => [...prev, { level: 'info', message: `⏳ Upload image galerie: ${galleryImage}`, time: now() }]);
                                        const formDataGallery = new FormData();
                                        formDataGallery.append('image', galleryImage);
                                        if (product.ref) formDataGallery.append('ref', product.ref);
                                        formDataGallery.append('role', 'gallery');
                                        imageUploadTasks.push(
                                            axios.post('https://atcjoaillerie.fr/api/wp_upload.php', formDataGallery)
                                                .then((res) => {
                                                    const data = res && res.data ? res.data : {};
                                                    if (data.status === 'ok') {
                                                        const details = [
                                                            `prod_id=${data.product_id}`,
                                                            `attach_id=${data.attachment_id}`,
                                                            `type=${data.product_type || '?'}`,
                                                            `méthode=${data.search_method || '?'}`,
                                                            `gallery: ${data.gallery_before || 0}→${data.gallery_after || 0}`
                                                        ].join(' ');
                                                        return {
                                                            level: 'success',
                                                            message: `Image galerie attachée`,
                                                            file: galleryImage,
                                                            time: now(),
                                                            details
                                                        };
                                                    } else {
                                                        const details = data.tried_methods ? ` (essayé: ${data.tried_methods})` : '';
                                                        return {
                                                            level: 'warning',
                                                            message: `Échec attache galerie: ${data.message || 'erreur'}${details}`,
                                                            file: galleryImage,
                                                            time: now(),
                                                        };
                                                    }
                                                })
                                                .catch(err => {
                                                    const data = err && err.response && err.response.data ? err.response.data : {};
                                                    const msg = data.message || err.message || 'inconnue';
                                                    return {
                                                        level: 'error',
                                                        message: `Erreur upload galerie: ${msg}`,
                                                        file: galleryImage,
                                                        time: now(),
                                                    };
                                                })
                                        );
                                        uploadedImages.add(galleryImage);
                                    }
                                }
                            }
                        }
                        // Regroupe les images de galerie au niveau du produit (utile côté import WP)
                        const productGallery = Array.from(new Set(
                            product.produits
                                .filter(v => Array.isArray(v.gallery) && v.gallery.length > 0)
                                .flatMap(v => v.gallery)
                        ));
                        product.gallery = productGallery;
                    }
                    setProgress(40);
                    // Upload en parallèle, logs structurés
                    const uploadResults = await Promise.allSettled(imageUploadTasks);
                    setConsoleMessages(prev => [
                        ...prev,
                        ...uploadResults.map(r => r.value || r.reason)
                    ]);
                    setConsoleMessages(prev => [...prev, { level: 'info', message: 'Mise à jour des produits...', time: now() }]);
                    setProgress(60);

                    // 5. Update produits (progressif)
                    setStatus('Mise à jour des produits...');
                    const productUpdateTasks = products.map(product => {
                        return axios.post('https://atcjoaillerie.fr/api/wp_import_products.php', product)
                            .then(() => ({
                                level: 'success',
                                message: `Produit ${product.ref} mis à jour${(product.gallery && product.gallery.length) ? ` (galerie ${product.gallery.length} image(s))` : ''}`,
                                time: now(),
                            }))
                            .catch(err => ({
                                level: 'error',
                                message: `Erreur update produit ${product.ref}`,
                                time: now(),
                                details: err.message
                            }));
                    });
                    const updateResults = await Promise.allSettled(productUpdateTasks);
                    setConsoleMessages(prev => [
                        ...prev,
                        ...updateResults.map(r => r.value || r.reason)
                    ]);
                    setProgress(80);

                    setStatus('Suppression des produits non utilisés...');
                    const data = { listProd, listVariation };
                    await axios.post('https://atcjoaillerie.fr/api/clean_prod.php', data);
                    setProgress(100);

                    setConsoleMessages(prev => [...prev, { level: 'success', message: 'Mise à jour terminée avec succès !', time: now() }]);
                    setStatus('Mise à jour terminée avec succès !');
                } catch (error) {
                    setConsoleMessages(prev => [...prev, { level: 'error', message: 'Erreur lors de la mise à jour', time: (new Date()).toLocaleTimeString(), details: error.message }]);
                    setStatus('Une erreur est survenue.');
                }
            };

    useEffect(() => {
        if (consoleEndRef.current) {
            consoleEndRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    }, [consoleMessages]);

    // Filtrage des logs
    const filteredMessages = logFilter === 'all' ? consoleMessages : consoleMessages.filter(m => (typeof m === 'string' ? true : m.level === logFilter));

    // Affichage pro : icône, couleur, timestamp, message, détails
    const logIcon = (level) => {
        switch (level) {
            case 'success': return <CheckCircle style={{ color: '#4caf50', marginRight: 4, verticalAlign: 'middle' }} />;
            case 'error': return <ErrorIcon style={{ color: '#f44336', marginRight: 4, verticalAlign: 'middle' }} />;
            case 'warning': return <Warning style={{ color: '#ff9800', marginRight: 4, verticalAlign: 'middle' }} />;
            case 'info': return <Info style={{ color: '#2196f3', marginRight: 4, verticalAlign: 'middle' }} />;
            default: return null;
        }
    };

    return (
        <Box sx={{ width: '100%', maxWidth: 700, margin: '0 auto', textAlign: 'center', padding: 2 }}>
            <Typography variant="h6" gutterBottom>
                Mise à jour des produits sur WordPress
            </Typography>
            <Button variant="contained" color="primary" onClick={handleUpdate} style={{ marginBottom: 12 }}>
                Lancer la mise à jour
            </Button>
            {progress > 0 && (
                <Box sx={{ width: '100%', mt: 2 }}>
                    <LinearProgress variant="determinate" value={progress} />
                    <Typography variant="body1" style={{ marginTop: 8 }}>
                        {status}
                    </Typography>
                </Box>
            )}
            {consoleMessages.length > 0 && (
                <Paper elevation={3} style={{ marginTop: 16, padding: 0, maxHeight: 420, overflow: 'auto', backgroundColor: '#181c1f', color: '#e0e0e0', fontFamily: 'monospace' }}>
                    <Box display="flex" alignItems="center" justifyContent="space-between" style={{ background: '#23272b', padding: '8px 16px' }}>
                        <Typography variant="h6" style={{ color: '#fff', fontWeight: 600 }}>Console</Typography>
                        <Box>
                            <Tooltip title="Tous"><IconButton size="small" onClick={() => setLogFilter('all')}><FilterList style={{ color: logFilter==='all' ? '#2196f3' : '#888' }} /></IconButton></Tooltip>
                            <Tooltip title="Succès"><IconButton size="small" onClick={() => setLogFilter('success')}><CheckCircle style={{ color: logFilter==='success' ? '#4caf50' : '#888' }} /></IconButton></Tooltip>
                            <Tooltip title="Infos"><IconButton size="small" onClick={() => setLogFilter('info')}><Info style={{ color: logFilter==='info' ? '#2196f3' : '#888' }} /></IconButton></Tooltip>
                            <Tooltip title="Avertissements"><IconButton size="small" onClick={() => setLogFilter('warning')}><Warning style={{ color: logFilter==='warning' ? '#ff9800' : '#888' }} /></IconButton></Tooltip>
                            <Tooltip title="Erreurs"><IconButton size="small" onClick={() => setLogFilter('error')}><ErrorIcon style={{ color: logFilter==='error' ? '#f44336' : '#888' }} /></IconButton></Tooltip>
                        </Box>
                    </Box>
                    <div style={{ maxHeight: 370, overflow: 'auto', padding: 0 }}>
                        {filteredMessages.map((msg, idx) => {
                            if (typeof msg === 'string') {
                                return (
                                    <Box key={idx} display="flex" alignItems="center" style={{ padding: '2px 12px', borderBottom: '1px solid #23272b' }}>
                                        <Info style={{ color: '#2196f3', marginRight: 4, fontSize: 18 }} />
                                        <span style={{ fontSize: 14 }}>{msg}</span>
                                    </Box>
                                );
                            }
                            return (
                                <Box key={idx} display="flex" alignItems="center" style={{ padding: '2px 12px', borderBottom: '1px solid #23272b' }}>
                                    {logIcon(msg.level)}
                                    <span style={{ fontWeight: 500, marginRight: 8, fontSize: 13 }}>{msg.time || ''}</span>
                                    <span style={{ fontSize: 14 }}>{msg.message}</span>
                                    {msg.file && <Chip size="small" label={msg.file} style={{ marginLeft: 8, background: '#23272b', color: '#fff' }} />}
                                    {msg.details && <span style={{ marginLeft: 8, color: '#aaa', fontSize: 12 }}>{msg.details}</span>}
                                </Box>
                            );
                        })}
                        <div ref={consoleEndRef} />
                    </div>
                </Paper>
            )}
        </Box>
    );
};

export default UpdateWordpress;
